import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import ImageUpload from '../components/ui/ImageUpload';
import { useAdminData } from '../contexts/AdminDataContext';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { RadioGroup } from '../components/ui/RadioGroup';
import { Toggle } from '../components/ui/Toggle';
import { Button } from '../components/ui/Button';
import { ArrowLeft, Sparkles, ChevronDown, ChevronUp, RefreshCw } from 'lucide-react';
const RewardCreate = () => {
  const navigate = useNavigate();
  const {
    createReward,
    showToast
  } = useAdminData();
  const [isLoading, setIsLoading] = useState(false);
  const [expandedProposal, setExpandedProposal] = useState<number | null>(null);
  // Form State
  const [formData, setFormData] = useState({
    type: 'multi-use',
    name: '',
    description: '',
    terms: '',
    cost: '',
    limitType: 'unlimited',
    limitQuantity: '',
    limitPerUser: false,
    startDate: '',
    endDate: '',
    locations: [] as string[],
    code: '',
    maxUses: '',
    image: '',
    partner: 'La Saponaria',
    partnerId: 'PTR-001',
    rewardType: 'Prodotto',
    location: 'Tutte le Sedi'
  });
  const aiProposals = [{
    id: 1,
    name: 'Set Attivi Puri (Fitoretinolo + Collagene Vegetale)',
    type: 'Prodotto Viso',
    cost: '60-70 punti',
    description: 'Duo di attivi concentrati anti-age: Fitoretinolo e Collagene Vegetale per skincare personalizzata',
    why: 'Trend prodotti anti-age naturali +22%. Attivi puri hanno 35% più riscatti nella fascia 60-75 punti. Alta domanda da segmento 35-50 anni.'
  }, {
    id: 2,
    name: 'Kit Cosmetici Solidi Completo',
    type: 'Cosmetici Solidi',
    cost: '45-55 punti',
    description: 'Shampo solido + Balsamo solido + Bagnoschiuma solido. Zero waste, plastic-free, 100% naturale',
    why: 'Cosmetici solidi zero-waste +25% nel periodo. Prodotti eco-friendly hanno retention 30% più alta. Perfetto per utenti attenti alla sostenibilità.'
  }];
  const handleInputChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleInsertProposal = (proposal: (typeof aiProposals)[0]) => {
    setFormData(prev => ({
      ...prev,
      name: proposal.name,
      description: proposal.description,
      cost: proposal.cost.split('-')[0].replace(' 💎', '').trim(),
      rewardType: proposal.type
    }));
    showToast('Campi aggiornati con suggerimento AI');
  };
  const handleGenerateVariant = () => {
    showToast('Nuova variante generata');
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Create reward object
    const newReward = {
      partnerId: formData.partnerId,
      code: formData.code || `RWD-${Date.now()}`,
      name: formData.name,
      partner: formData.partner,
      type: formData.rewardType,
      status: 'Attivo' as const,
      cost: parseInt(formData.cost) || 0,
      image: formData.image || 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=200&h=200&fit=crop',
      availability: {
        current: formData.limitType === 'unlimited' ? 0 : parseInt(formData.limitQuantity) || 0,
        total: formData.limitType === 'unlimited' ? 0 : parseInt(formData.limitQuantity) || 0,
        unlimited: formData.limitType === 'unlimited'
      },
      redemptionsPeriod: 0,
      redemptionsTotal: 0,
      lastRedemption: 'Mai',
      location: formData.location,
      startDate: formData.startDate || null,
      endDate: formData.endDate || null
    };
    setTimeout(() => {
      createReward(newReward);
      setIsLoading(false);
      navigate('/rewards');
    }, 1000);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-3228">
      <div className="w-20 flex-shrink-0" data-id="element-3229">
        <Sidebar data-id="element-3230" />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3231">
        <Topbar data-id="element-3232" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3233">
          <div className="mb-6" data-id="element-3234">
            <button onClick={() => navigate('/rewards')} className="flex items-center text-sm text-gray-500 hover:text-gray-900 mb-4" data-id="element-3235">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-3236" />
              Torna ai premi
            </button>
            <PageHeader title="Crea premio" subtitle="Configura un'offerta riscattabile con diamond." data-id="element-3237" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3238">
            {/* Main Form - 2 columns */}
            <div className="lg:col-span-2" data-id="element-3239">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3240">
                {/* 1. Tipo Premio */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3241">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3242">
                    Tipo di Premio
                  </h3>
                  <RadioGroup name="type" value={formData.type} onChange={val => handleInputChange('type', val)} options={[{
                  value: 'multi-use',
                  label: 'Codice sconto multi-uso',
                  description: 'Un unico codice utilizzabile da più utenti (es. SUMMER2025)'
                }, {
                  value: 'one-time',
                  label: 'Offerta one-time',
                  description: 'Codici univoci, ognuno valido una sola volta'
                }, {
                  value: 'other',
                  label: 'Altro',
                  description: 'Premi fisici, eventi o altre tipologie senza codice'
                }]} helperText="Scegli il metodo di riscatto più adatto." data-id="element-3243" />
                </div>

                {/* 2. Dettagli */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3244">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3245">
                    Dettagli
                  </h3>
                  <div className="space-y-4" data-id="element-3246">
                    <Input label="Nome premio" placeholder="Es. Buono Amazon €50" value={formData.name} onChange={e => handleInputChange('name', e.target.value)} required data-id="element-3247" />

                    <div data-id="element-3248">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3249">
                        Partner
                      </label>
                      <select value={formData.partner} onChange={e => {
                      handleInputChange('partner', e.target.value);
                      // Map partner to partnerId
                      const partnerMap: Record<string, string> = {
                        'La Saponaria': 'PTR-001',
                        NaturaSì: 'PTR-002',
                        BioSapori: 'PTR-003'
                      };
                      handleInputChange('partnerId', partnerMap[e.target.value] || 'PTR-001');
                    }} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-3250">
                        <option value="La Saponaria" data-id="element-3251">La Saponaria</option>
                        <option value="NaturaSì" data-id="element-3252">NaturaSì</option>
                        <option value="BioSapori" data-id="element-3253">BioSapori</option>
                      </select>
                    </div>

                    <Input label="Tipo premio" placeholder="Es. Prodotto Viso, Buono Sconto, Workshop" value={formData.rewardType} onChange={e => handleInputChange('rewardType', e.target.value)} data-id="element-3254" />

                    <Textarea label="Descrizione breve" placeholder="Descrivi cosa riceverà l'utente..." value={formData.description} onChange={e => handleInputChange('description', e.target.value)} rows={3} data-id="element-3255" />
                    <Textarea label="Termini e Condizioni" placeholder="Inserisci eventuali limitazioni o istruzioni per l'uso..." value={formData.terms} onChange={e => handleInputChange('terms', e.target.value)} rows={3} data-id="element-3256" />

                    <ImageUpload label="Immagine premio" currentImage={formData.image} onImageChange={url => handleInputChange('image', url)} helperText="Carica un'immagine rappresentativa del premio" data-id="element-3257" />
                  </div>
                </div>

                {/* 3. Diamond e Limiti */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3258">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3259">
                    Diamond e Limiti
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3260">
                    <Input label="Costo in Diamond" type="number" placeholder="0" value={formData.cost} onChange={e => handleInputChange('cost', e.target.value)} required min="0" data-id="element-3261" />
                    <div data-id="element-3262">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3263">
                        Disponibilità
                      </label>
                      <div className="flex gap-4 mb-3" data-id="element-3264">
                        <label className="flex items-center" data-id="element-3265">
                          <input type="radio" name="limitType" value="unlimited" checked={formData.limitType === 'unlimited'} onChange={() => handleInputChange('limitType', 'unlimited')} className="text-green-600 focus:ring-green-600" data-id="element-3266" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-3267">
                            Illimitata
                          </span>
                        </label>
                        <label className="flex items-center" data-id="element-3268">
                          <input type="radio" name="limitType" value="limited" checked={formData.limitType === 'limited'} onChange={() => handleInputChange('limitType', 'limited')} className="text-green-600 focus:ring-green-600" data-id="element-3269" />
                          <span className="ml-2 text-sm text-gray-700" data-id="element-3270">
                            Limitata
                          </span>
                        </label>
                      </div>
                      {formData.limitType === 'limited' && <Input type="number" placeholder="Quantità totale" value={formData.limitQuantity} onChange={e => handleInputChange('limitQuantity', e.target.value)} min="1" data-id="element-3271" />}
                    </div>
                  </div>
                  <div className="pt-4 border-t border-gray-100" data-id="element-3272">
                    <Toggle label="Limite per utente" description="Consenti un solo riscatto per utente" checked={formData.limitPerUser} onChange={val => handleInputChange('limitPerUser', val)} data-id="element-3273" />
                  </div>
                </div>

                {/* 4. Validità e Sedi */}
                <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3274">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3275">
                    Validità e Sedi
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3276">
                    <Input label="Data inizio (opzionale)" type="date" value={formData.startDate} onChange={e => handleInputChange('startDate', e.target.value)} data-id="element-3277" />
                    <Input label="Data fine (opzionale)" type="date" value={formData.endDate} onChange={e => handleInputChange('endDate', e.target.value)} data-id="element-3278" />
                  </div>
                  <div data-id="element-3279">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3280">
                      Sede applicabile
                    </label>
                    <input type="text" placeholder="Es. Milano Centro, Tutte le Sedi" value={formData.location} onChange={e => handleInputChange('location', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-3281" />
                  </div>
                </div>

                {/* Sezione Codici (Condizionale) */}
                {formData.type === 'multi-use' && <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-3282">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-3283">
                      Configurazione Codice
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3284">
                      <Input label="Codice promozionale" placeholder="Es. SUMMER2025" value={formData.code} onChange={e => handleInputChange('code', e.target.value)} data-id="element-3285" />
                      <Input label="Numero massimo utilizzi (opzionale)" type="number" placeholder="Illimitato" value={formData.maxUses} onChange={e => handleInputChange('maxUses', e.target.value)} data-id="element-3286" />
                    </div>
                  </div>}

                {/* Actions */}
                <div className="flex items-center justify-end gap-3 pt-4 pb-10" data-id="element-3287">
                  <Button type="button" variant="ghost" onClick={() => navigate('/rewards')} data-id="element-3288">
                    Annulla
                  </Button>
                  <Button type="submit" variant="primary" isLoading={isLoading} data-id="element-3289">
                    Pubblica premio
                  </Button>
                </div>
              </form>
            </div>

            {/* AI Assistant Sidebar - 1 column */}
            <div className="lg:col-span-1" data-id="element-3290">
              <div className="sticky top-6 space-y-4" data-id="element-3291">
                <div className="rounded-lg p-5 shadow-sm" style={{
                background: 'linear-gradient(135deg, rgba(255, 0, 77, 0.05) 0%, rgba(116, 10, 214, 0.05) 100%)',
                borderLeft: '4px solid',
                borderImage: 'linear-gradient(180deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%) 1'
              }} data-id="element-3292">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3293">
                    <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full" style={{
                    background: 'linear-gradient(90deg, rgba(255, 0, 77, 0.1) 0%, rgba(116, 10, 214, 0.1) 100%)'
                  }} data-id="element-3294">
                      <Sparkles className="h-4 w-4" style={{
                      color: '#740AD6'
                    }} data-id="element-3295" />
                      <span className="text-xs font-semibold" style={{
                      color: '#740AD6'
                    }} data-id="element-3296">
                        AI
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-gray-900" data-id="element-3297">
                      Assistente Offerte
                    </h3>
                  </div>

                  <div className="space-y-3 mb-4" data-id="element-3298">
                    {aiProposals.map(proposal => <div key={proposal.id} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-3299">
                        <div className="mb-3" data-id="element-3300">
                          <h4 className="font-medium text-gray-900 mb-1" data-id="element-3301">
                            {proposal.name}
                          </h4>
                          <div className="flex items-center gap-2 text-xs mb-2" data-id="element-3302">
                            <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full" data-id="element-3303">
                              {proposal.type}
                            </span>
                            <span className="text-gray-600" data-id="element-3304">
                              {proposal.cost}
                            </span>
                          </div>
                          <p className="text-sm text-gray-600" data-id="element-3305">
                            {proposal.description}
                          </p>
                        </div>

                        <button onClick={() => setExpandedProposal(expandedProposal === proposal.id ? null : proposal.id)} className="flex items-center gap-1 text-xs transition-colors mb-2" style={{
                      color: '#740AD6'
                    }} data-id="element-3306">
                          Perché questo?
                          {expandedProposal === proposal.id ? <ChevronUp className="h-3 w-3" data-id="element-3307" /> : <ChevronDown className="h-3 w-3" data-id="element-3308" />}
                        </button>

                        {expandedProposal === proposal.id && <div className="mb-3 p-3 bg-gray-50 rounded text-xs text-gray-600 border-t border-gray-200" data-id="element-3309">
                            {proposal.why}
                          </div>}

                        <div className="flex gap-2" data-id="element-3310">
                          <button type="button" onClick={() => handleInsertProposal(proposal)} className="flex-1 text-xs font-medium py-2 px-3 border transition-colors" style={{
                        color: '#740AD6',
                        borderColor: '#740AD6',
                        borderRadius: '100px'
                      }} data-id="element-3311">
                            Inserisci nel form
                          </button>
                          <button type="button" onClick={handleGenerateVariant} className="p-2 text-gray-500 hover:text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" title="Genera variante" data-id="element-3312">
                            <RefreshCw className="h-4 w-4" data-id="element-3313" />
                          </button>
                        </div>
                      </div>)}
                  </div>

                  <p className="text-xs text-gray-400 pt-4 border-t border-gray-200" data-id="element-3314">
                    Basato su dati aggregati. Nessun dato personale.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default RewardCreate;